/* Publish by EComposer at 2026-10-12 08:19:41*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0v7xf1obhhe"]=  window.__ectimmers["ecom-0v7xf1obhhe"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-0v7xf1obhhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0v7xf1obhhe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1akhiq5kt7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1akhiq5kt7b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9y4m51ftaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9y4m51ftaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8o2dgb5zo0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8o2dgb5zo0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6brxv3qno23').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6brxv3qno23', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8opgz4tyfty').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8opgz4tyfty', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-26bc724e8jm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26bc724e8jm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6md2c0sqvcy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6md2c0sqvcy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96j1f5z0rs7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96j1f5z0rs7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5j6pq6b57').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5j6pq6b57', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qzyxb504v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qzyxb504v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2nut33y4ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2nut33y4ws', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9usms9cjda5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9usms9cjda5', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bv2z4f4yzsa"]=  window.__ectimmers["ecom-bv2z4f4yzsa"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-bv2z4f4yzsa"]["pj3u40sum"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-bv2z4f4yzsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bv2z4f4yzsa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xta1i7agr2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xta1i7agr2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1c3mq9uxr8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1c3mq9uxr8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u59mbgn88h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u59mbgn88h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w846407wk99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w846407wk99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c2ura8yah8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c2ura8yah8f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wxi83oaqb1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wxi83oaqb1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jqt9dgoaau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jqt9dgoaau', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htteb25jcdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htteb25jcdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-afvye11iggj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-afvye11iggj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxuubph0ijg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxuubph0ijg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbvf4ed6ijl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbvf4ed6ijl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9hxfurjk1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9hxfurjk1', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uxmx39drq1h"]=  window.__ectimmers["ecom-uxmx39drq1h"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-uxmx39drq1h"]["51vz5ecc4"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-uxmx39drq1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxmx39drq1h', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bg7gbe29tdw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bg7gbe29tdw', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0buy69ndqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0buy69ndqh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fh4zrzfje6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fh4zrzfje6p', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jmqizh4b76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jmqizh4b76', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvz95xe2b7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvz95xe2b7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwgdtv9u1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwgdtv9u1z', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lllpni11rif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lllpni11rif', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wb5hsgszfwm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wb5hsgszfwm', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cmuusdoo3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cmuusdoo3o', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-utn5owbzfoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utn5owbzfoq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l23qn1ojf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l23qn1ojf8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5r3tg1vx0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5r3tg1vx0r', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 try{
 
} catch(error){console.error(error);}
} catch(error){console.error(error);}